import { Currency } from '@/core/currency/interfaces';

const BBD: Currency = {
    name: 'Barbadian Dollar',
    demonym: 'Barbadian',
    majorSingle: 'Dollar',
    majorPlural: 'Dollars',
    codeNumeric: '052',
    symbol: 'BBD$',
    symbolNative: '$',
    minorSingle: 'Cent',
    minorPlural: 'Cents',
    ISOdigits: 2,
    decimals: 2,
    numToBasic: 100,
    code: 'BBD',
    delimiters: {
        thousands: '.',
        decimal: ','
    }
};

export default BBD;
